import createAxios from 'config/axios'
import * as token from '../utils/token'

const cpfFromToken = token.getCpf()
const GET_URL = `/bope/v1/devices/${cpfFromToken}`
const POST_URL = '/bope/v1/devices'

export const getEasyToken = () => createAxios.get(GET_URL)

export const postEasyToken = data => createAxios.post(POST_URL, data)

